import { gql } from '@apollo/client';

export const dcSession = gql`
  query DcSession($input: DcSessionInput) {
    dcSession(input: $input) {
      sessionId
    }
  }
`;
